import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/narzedzia/[calculator]/client/ClientCalculatorPage.tsx");
